import {t} from './translate'

export function getPwdError (password, confirm) {
  if (confirm.length > 0 && password.length < 8) {
    return t('Your password must be at least 8 characters long'); 
  }
  if (password != confirm) {
    return t('Your passwords do not match')
  }
  return false
}

export function validateEmail(email) {
  const format = /\S+@\S+\.\S+/;
  return format.test(email);
}

export function getColSize(element) {
  if (!element) return 2;  
  return  element.col_sm ? element.col_sm : 2;
}


// WEBPACK FOOTER //
// ./src/helpers/common.js